// extracted by mini-css-extract-plugin
module.exports = {"container":"container__YnXTL","main":"main__2YSzN","text":"text__1EJpc","img":"img__1hPk9","block":"block__1V3OD","blockimg":"blockimg__3btBY"};